module.exports = __webpack_public_path__ + "img/bj.4fb5b8c2.png";